module.exports = __webpack_public_path__ + "img/dataDoc2.64e6c50d.png";